import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import { fetchWarehouses, deleteWarehouse } from "../../services/warehouses";
import { _swal } from "../../utils/helper";

function WarehousesList() {
  const [warehousesData, setWarehousesData] = useState({});
  const searchSchema = {
    name: null,
    city: null,
  };
  const [WarehouseSearchValues, setWarehouseSearchValues] =
    useState(searchSchema);
  const _fetchWarehouses = async (queryParams = {}) => {
    await fetchWarehouses(queryParams)
      .then((response) => {
        const { data } = response;
        setWarehousesData(data.data.warehouses);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const _deleteWarehouse = async (id) => {
    const _confirm = window.confirm("Are you sure to delete?");
    if (_confirm) {
      await deleteWarehouse(id)
        .then((response) => {
          const { data } = response;
          _swal(response.data.status, response.data.message);
          _fetchWarehouses();
        })
        .catch((err) => {
          _swal(err.response.data.status, err.response.data.message);
          console.log(err.response.data);
        });
    }
  };
  const resetSearch = () => {
    _fetchWarehouses({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  };
  const filterWarehouse = (
    page = null,
    sort_column = null,
    sort_order = null
  ) => {
    const filteredKeys = {};
    Object.entries(WarehouseSearchValues).filter((v) => {
      if (v[1] !== null) {
        filteredKeys[v[0]] = v[1];
      }
    });
    _fetchWarehouses({
      ...filteredKeys,
      page: page ? page : 1,
      per_page: 100,
      sort_column: sort_column ? sort_column : "id",
      sort_order: sort_order ? sort_order : "DESC",
    });
  };
  useEffect(() => {
    _fetchWarehouses({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  }, []);
  return (
    <Container className="my-2">
      <Card>
        <Card.Header as="h5">
        Supplier Locations{" "}
          <Button
            variant="primary"
            as={Link}
            to={"/seller/warehouses/create"}
            size="sm"
          >
            New
          </Button>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="3">
                <Form.Group className="mb-3">
                  <Form.Label>Supplier Location Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={
                      WarehouseSearchValues.name !== null
                        ? WarehouseSearchValues.name
                        : ""
                    }
                    onChange={(e) =>
                      setWarehouseSearchValues({
                        ...WarehouseSearchValues,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    placeholder="City"
                    value={
                      WarehouseSearchValues.city !== null
                        ? WarehouseSearchValues.city
                        : ""
                    }
                    onChange={(e) =>
                      setWarehouseSearchValues({
                        ...WarehouseSearchValues,
                        city: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              onClick={() => filterWarehouse()}
              variant="primary"
              className="mr-2"
            >
              Filter
            </Button>
            <Button
              onClick={(e) => {
                setWarehouseSearchValues({ ...searchSchema });
                resetSearch();
              }}
              variant="default"
            >
              Reset
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <Table bordered width={"100%"} className="mt-2">
        <thead>
          <tr>
            <th width="15%">Name</th>
            <th width="15%">Address</th>
            <th width="15%">City</th>
            <th width="15%">Phone Number</th>
            <th width="15%" className="text-center">
              Status
            </th>
            <th width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          {warehousesData.length ? (
            warehousesData.map((e) => {
              return (
                <tr>
                  <td>{e.name}</td>
                  <td>
                    {e.address_1} {e.address_2}
                  </td>
                  <td>{e.city}</td>
                  <td>{e.phone_number}</td>
                  <td className="text-center">{e.status}</td>
                  <td>
                    <Button
                      variant="default"
                      as={Link}
                      to={"/seller/Warehouses/" + e.id + "/edit"}
                      size="sm"
                    >
                      Edit
                    </Button>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => _deleteWarehouse(e.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={"3"}>Warehouses not found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}

export default WarehousesList;
